import { useViewerOpenLoader } from './useViewerOpenLoader';

/**
 * Loads a worklist open that has already been retrieved: parses, commits,
 * renders. Renders nothing itself: the parse overlay is the viewer route's
 * shared `FilesProcessed`, and a patient conflict is asked in the app's one
 * conflict dialog.
 */
export default function ViewerOpenLoader() {
    useViewerOpenLoader();
    return null;
}
